import axios from 'axios'
import { containsJapanese } from '@/utils/japaneseText'

/**
 * 失敗した応答の文のうち、日本語を含まないものを取り除く（2026-09-22）。
 *
 * ## なぜ要るのか
 *
 * サーバが自分で作る断りの文は日本語だが、サーバの手前で断られたとき
 * （経路が無い・ログインが切れた など）は、既定の英語の文
 * （Forbidden・No message available）が返ってくる。画面の多くは
 * `error.response.data.message` があればそれを出すので、英語がそのまま出ていた。
 *
 * **1か所で塞ぐ。**ここで英語の文を取り除けば、各画面は元から持っている
 * 日本語の予備の文を出す。画面ごとに書き足すと、足し忘れた画面から漏れる。
 * 符号（code など）は触らない。判定に使っている画面があるため。
 *
 * @returns 取り外す関数（検査で使う）
 */
export function installJapaneseOnlyMessages () {
  const id = axios.interceptors.response.use(
    response => response,
    error => {
      const response = error && error.response
      if (response) {
        const data = response.data
        if (data && typeof data === 'object' && typeof data.message === 'string' &&
          !containsJapanese(data.message)) {
          delete data.message
        } else if (typeof data === 'string' && data.trim() && !containsJapanese(data)) {
          response.data = ''
        }
      }
      return Promise.reject(error)
    }
  )
  return () => axios.interceptors.response.eject(id)
}
